/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EHttpStatusCode {
  Ok = 200,
  InternalServerError = 500
}
